import styled, { css } from 'styled-components';

export const Container = styled.div<{ centerNotifications: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  grid-row-gap: 10px;
  padding: 24px 16px;
  box-sizing: border-box;

  ${(props) =>
    props.centerNotifications &&
    css`
      justify-content: center;
      align-items: center;
      width: 100%;
    `};
`;
